const authCz = {
    "sign_in": "Přihlásit se",
    "email": "E-mailová adresa",
    "password": "Heslo",
    "sign_in_button": "Přihlásit se",
    "invalid_credentials": "Neplatné přihlašovací údaje",
    "password_min_length": "Heslo musí mít alespoň 8 znaků",
    "passwords_do_not_match": "Hesla se neshodují",
    "invalid_token": "Neplatný token",
    "password_set": "Heslo nastaveno",
    "confirm_password": "Potvrzení hesla",
    "confirm_title": "Potvrzení registrace administrátora Quickpick",
    "confirm_text": "Pro nastavení účtu stačí zadat bezpečné heslo",
    "set_password": "Nastavit heslo",
    "account_activated": "Účet aktivován",
    "account_activated_text": "Nyní se můžete přihlásit ke svému uživatelskému účtu pomocí zadané e-mailové adresy a hesla.",
    "continue_to_login": "Pokračovat k přihlášení",
    "forgotten_password": "Zapomenuté heslo",
    "unable_to_reset_password": "Interní chyba, heslo nelze resetovat.",
    "reset_password_title": "Obnovit heslo",
    "reset_password_text": "Zadejte prosím e-mailovou adresu, kterou používáte pro svůj účet. Na tuto e-mailovou adresu vám zašleme odkaz pro obnovení hesla.",
    "send_reset_mail": "Odeslat odkaz pro obnovení hesla",
    "send_reset_mail_success": "Na uvedenou adresu byl odeslán e-mail s dalšími pokyny.",
    "invalid_email": "Neplatná e-mailová adresa",
    "reset_sent": "E-mail odeslán",
    "change_password_title": "Změnit heslo",
    "change_password_success": "Heslo bylo úspěšně změněno",
    "roles": {
        "OWNER": "Administrátor",
        "MENU_EDITOR": "Úprava menu",
        "STAFF_MANAGER": "Řízení zaměstnanců"
    },
    "name": "Jméno",
    "permissions": "Oprávnění",
    "create_user_permissions": "Vytvořit uživatelská oprávnění",
    "add_restaurant": "Přidat restauraci",
    "user_saved": "Uživatel uložen",
    "has_admin_permissions": "Oprávnění správce",
    "login_with_google": "Přihlášení přes Google",
    "missing_perrmissions": "Nemáte potřebná oprávnění pro přístup k této stránce.",
    "qp_signup_title": "Registrace QuickPick",
    "qp_signup_text": "Vyplňte níže uvedená pole pro vytvoření uživatelského účtu!",
    "user_information": "Informace o uživateli",
    "restaurant_information": "Informace o restauraci",
    "restaurant_shortname": "Identifikátor restaurace",
    "restaurant_name": "Název restaurace",
    "create_profile": "Vytvořit",
    "restaurant_name_short": "Název restaurace musí mít alespoň 3 znaky",
    "identifier_example": "Příklad identifikátoru",
    "invalid_shortname": "Identifikátor restaurace musí mít alespoň 3 znaky.",
    "restaurant_shortname_already_in_use": "Identifikátor restaurace se již používá",
    "name_missing": "Chybí jméno",
    "signup_failed": "Registrace se nezdařila. Zkuste to prosím znovu později.",
    "no_restaurant_title": "Pro váš účet nebyla vybrána žádná restaurace",
    "no_restaurant_text": "Pokud jste si právě vytvořili účet, měli byste také zaregistrovat svou restauraci!",
    "no_restaurant_alt": "Pokud byste měli získat přístup do restaurace, kontaktujte prosím správce restaurace.",
    "no_user_created_yet": "Ještě nemáte účet?",
    "signup_success": "Registrace úspěšná",
    "grant_admin_title": "Udělit oprávnění správce",
    "grant_admin_confirmation": "Uživatel s administrátorskými oprávněními může spravovat nastavení restaurace, přidávat a odebírat uživatele, spravovat předplatné, platby a faktury. Úprava menu nevyžaduje administrátorská oprávnění.",
    "selected_user": "Vybraný uživatel",
    "delete_user_title": "Odebrat uživatele",
    "delete_user_confirmation": "Vybraný uživatel bude z restaurace odstraněn a již nebude mít přístup k jejímu menu. Tuto akci nelze vrátit zpět.",
    "admin": "Administrátor",
    "activate_account": "Aktivovat účet",
    "account_pending_activation": "Váš uživatelský účet čeká na aktivaci.",
    "check_your_activate_email": "Zkontrolujte si prosím doručenou e-mailovou schránku a klikněte na aktivační odkaz.",
    "refresh_page": "Obnovit stránku",
    "did_not_receive_activation_email": "Neobdržel(a) jsem aktivační e-mail",
    "activate_tip": "Pokud aktivační e-mail nemůžete najít, zkontrolujte také složku s nevyžádanou poštou. Pokud tam není, klikněte na tlačítko níže a odešlete jej znovu.",
    "resend_email": "Znovu odeslat",
    "email_resent": "Aktivační e-mail byl úspěšně znovu odeslán. Zkontrolujte prosím svou e-mailovou schránku.",
    "accept_terms_and_conditions": "Přečetl(a) jsem si a souhlasím se <a>Smluvními podmínkami a Zásadami ochrany osobních údajů</a>",
    "complete_registration": "Dokončit registraci",
    "auth_in_progress": "Probíhá ověřování...",
    "account_successfully_activated": "Váš účet QuickPick byl úspěšně aktivován",
    "continue_to_home_page": "Pokračovat na domovskou stránku",
    "invalid_activation": "Při aktivaci účtu došlo k chybě. Zkuste to prosím znovu později nebo kontaktujte naši zákaznickou podporu.",
    "activation_mail_sent": "Začali jsme vytvářet váš účet. Zkontrolujte si prosím svou e-mailovou schránku a dokončete registraci kliknutím na odkaz v e-mailu."
};

export default authCz;
